<template>
	<div class="educations-wrap">
		<div class="educations-title">教育经历</div>
		<!-- 已添加教育经历列表 -->
		<div class="educations-items" v-if="educations.length > 0">
			<template v-for="(edu, n) in educations">
				<div class="educations-item" :key="n" v-if="eduIndex !== n">
					<edu-list :eduList="edu" :index="n" :eduLength="educations.length"></edu-list>
				</div>
			</template>
		</div>
		<!-- 教育经历操作区 -->
		<div class="educations-add">
			<transition name="slide-fade">
				<span
					v-if="educations.length > 0 && eduState === 0"
					class="educations-add-btn"
					@click="addEdu">
					<img
						src="../../../assets/img/ic_add.png"
						class="educations-add-icon">
					<span>添加教育经历</span>
				</span>
				<edu-add v-else></edu-add>
			</transition>
		</div>
	</div>
</template>

<script>
import * as types from '../../../store/mutation-types';
import { mapGetters } from 'vuex';
import EduList from './eduList';
import EduAdd from './eduAdd';
export default {
	methods: {
		/**
		 * 进入新增状态
		 */
		addEdu() {
			window.scrollTo(0, document.documentElement.clientHeight);
			this.$store.commit(types.CHANGE_EDUTION, {
				key: 'eduState',
				value: 1
			});
			this.$store.commit(types.CHANGE_EDUTION, {
				key: 'eduIndex',
				value: -1
			});
			// 新增教育经历点击埋点
			window.clickLog &&
				window.clickLog('from=xiaozhao_resumecreate_addeducation');
		}
	},
	computed: mapGetters([
		'educations',
		'eduIndex',
		'eduState'
	]),
	components: {
		EduList,
		EduAdd
	}
};
</script>
<style lang="scss">
@import '../../../assets/style/public.scss';
// slide-fade 淡入淡出
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.educations-wrap {
	background: #fff;
  .educations-title {
    padding: px2rem(30px) px2rem(30px) px2rem(15px);
    font-family: PingFangSC-Regular;
    font-size: px2rem(28px);
    color: #999;
  }
  .educations-add {
    text-align: center;
  }
  .educations-add-btn {
    position: relative;
    display: inline-block;
    margin: px2rem(35px) auto;
    padding: px2rem(6px) px2rem(18px);
    border: 1px solid rgba(255, 85, 46, 0.8);
    border-radius: px2rem(124px);
    color: #ff552e;
		span {
			vertical-align: middle;
		}
		.educations-add-icon {
			width: px2rem(32px);
			height: px2rem(32px);
			vertical-align: middle;
		}
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?6ab28145